/**
 * 收件地址类型（用于异常单列表）
 */
export interface RecipientAddressType {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipcode?: string;
}

/**
 * 异常单列表项类型
 */
export interface ExceptionOrderListItem {
    id: string;
    orderId: string;
    trackingNumber: string;
    exceptionReasonCode?: string;
    exceptionPriority: number;
    nextAction: number;
    exceptionStatus: number;
    parcelStatus: number;
    markExceptionAt?: string;
    putawayAt?: string;
    pickingAt?: string;
    markExceptionOperator?: string;
    orderStatus?: number;
    recipientAddress?: RecipientAddressType;
    recipientPostalCode?: string;
    deliveryAttempts?: number;
    currentWarehouseId?: string;
    clientName?: string;
    hubName?: string;
    warehouseName?: string;
    dspName?: string;
    driverName?: string;
    markExceptionOperatorName?: string;
    warehouseLocationCode?: string;
    storageNumber?: number;
    returnToWhsAt?: string;
    putawayDays?: number;
    isOverdue: boolean;
    createdAt?: string;
    updatedAt?: string;
}

/**
 * 异常单列表响应类型
 */
export interface ExceptionOrderListResponse {
    items: ExceptionOrderListItem[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

/**
 * 异常单筛选条件类型（对应后端 ExceptionOrderFiltersType，框架会自动添加 Input 后缀）
 */
export interface ExceptionOrderFilters {
    trackingNumbers?: string; // 运单号查询，支持批量（逗号、空格、换行分隔），单个时精确匹配
    clientId?: string; // GraphQL ID 类型，前端使用 string
    exceptionReasonCodes?: string[];
    exceptionStatus?: number[];
    nextActions?: number[];
    markExceptionAtFrom?: number; // epoch seconds
    markExceptionAtTo?: number; // epoch seconds
    returnToWhsAtFrom?: number; // epoch seconds
    returnToWhsAtTo?: number; // epoch seconds
    putawayAtFrom?: number; // epoch seconds
    putawayAtTo?: number; // epoch seconds
    warehouseLocationCode?: string;
    storageNumber?: string;
    overallStatus?: number[]; // 订单状态列表
    nextAction?: number;
    parcelStatus?: number;
    tab?: ExceptionTab | string; // GraphQL 中是 String，对应后端 ExceptionTab 枚举
    subTab?: ExceptionSubTab | string; // GraphQL 中是 String，对应后端 ExceptionSubTab 枚举
    pageNumber?: number;
    pageSize?: number;
}

/**
 * 异常单计数筛选条件类型（对应后端 ExceptionOrderCountFiltersType）
 */
export interface ExceptionOrderCountFilters {
    trackingNumbers?: string;
    clientId?: string;
    exceptionReasonCodes?: string[];
    exceptionStatus?: number[];
    nextActions?: number[];
    markExceptionAtFrom?: number;
    markExceptionAtTo?: number;
    returnToWhsAtFrom?: number;
    returnToWhsAtTo?: number;
    putawayAtFrom?: number;
    putawayAtTo?: number;
    warehouseLocationCode?: string;
    storageNumber?: string;
    overallStatus?: number[]; // 订单状态列表
    nextAction?: number;
    parcelStatus?: number;
    tab?: ExceptionTab | string; // 新增：确保计数查询也支持tab字段
    subTab?: ExceptionSubTab | string;
}

/**
 * 异常Tab枚举
 */
export enum ExceptionTab {
    WAREHOUSE_SUSPECTED_LOST = 'WAREHOUSE_SUSPECTED_LOST',
    DRIVER_RETURN = 'DRIVER_RETURN',
    OTHER_EXCEPTIONS = 'OTHER_EXCEPTIONS'
}

/**
 * 子Tab类型
 */
export type ExceptionSubTab =
    | 'all'
    | 'pending_putaway'
    | 'putaway'
    | 'pending_picking'
    | 'picked'
    | 'missing'
    | 'long_missing'
    | 'damaged'
    | 'missort'
    | 'oversize';

/**
 * 根据Tab查询异常单列表响应接口
 */
export interface QueryExceptionOrdersByTabResponse {
    queryExceptionOrdersByTab: ExceptionOrderListResponse;
}
